import script from "./SvgBackground.vue?vue&type=script&setup=true&lang=js"
export * from "./SvgBackground.vue?vue&type=script&setup=true&lang=js"

import "./SvgBackground.vue?vue&type=style&index=0&id=7446766f&scoped=true&lang=css"

import exportComponent from "/home/passani/git_repos/onlineimageoptimizer.com/image-optimizer-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7446766f"]])

export default __exports__